import { Pipe, PipeTransform } from '@angular/core';
import { getActivityItemState } from './activity.functions';

@Pipe({
  name: 'activityItemState'
})
export class ActivityItemStatePipe implements PipeTransform {
    transform(activity?: any): string {
        return getActivityItemState(activity);
    }
};